export enum EbookReviewEnum {
  NOT_PERMITTED_TO_REVIEW = 'NOT_PERMITTED_TO_REVIEW',
  BUYER_PERMITTED_TO_REVIEW = 'BUYER_PERMITTED_TO_REVIEW',
  EVERYONE_PERMITTED_TO_REVIEW = 'EVERYONE_PERMITTED_TO_REVIEW',
}
